import "react-simple-keyboard/build/css/index.css";

import Keyboard, { SimpleKeyboard } from "react-simple-keyboard";

import React, { useImperativeHandle, useRef } from "react";

import { LAYOUT, LAYOUT_DISPLAY, LayoutType } from "./const";

export { type LayoutType };

export interface VirtualKeyboardProps {
  layoutName?: LayoutType;
  inputName?: string;
  disableButtonHold?: boolean;
  onChange?: (input: string, e?: MouseEvent) => void;
  onKeyPress?: (key: string) => void;
}

export interface VirtualKeyboardRef {
  setInput: (
    input: string,
    inputName?: string | undefined,
    skipSync?: boolean | undefined,
  ) => void;
  setCaretPosition: (
    position: number | null,
    endPosition?: number | null | undefined,
  ) => void;
}

const VirtualKeyboard = React.forwardRef<
  VirtualKeyboardRef,
  VirtualKeyboardProps
>((props, ref) => {
  const { layoutName = "default" } = props;

  const keyboardRef = useRef<SimpleKeyboard>();

  useImperativeHandle(ref, () => ({
    setInput: (
      input: string,
      inputName?: string | undefined,
      skipSync?: boolean | undefined,
    ) => {
      if (!keyboardRef.current) {
        return;
      }

      keyboardRef.current.setInput(input, inputName, skipSync);
    },
    setCaretPosition: (
      position: number | null,
      endPosition?: number | null | undefined,
    ) => {
      if (!keyboardRef.current) {
        return;
      }

      keyboardRef.current.setCaretPosition(position, endPosition);
    },
  }));

  return (
    <Keyboard
      {...props}
      keyboardRef={(ref) => {
        keyboardRef.current = ref;
      }}
      tabCharOnTab={false}
      mergeDisplay
      layout={LAYOUT}
      display={LAYOUT_DISPLAY[layoutName]}
      preventMouseDownDefault
    />
  );
});

export default VirtualKeyboard;
